(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sitemap', {
            parent: 'app',
            url: '/sitemap',
            data: {
                authorities: [],
                pageTitle: 'global.menu.sitemap'
            },
            views: {
                'content@': {
                    templateUrl: 'app/sitemap/sitemap.html',
                    controller: 'SitemapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sitemap');
                    return $translate.refresh();
                }]
            }
        })
        .state('budget', {
            parent: 'app',
            url: '/budget',
            data: {
                authorities: [],
                pageTitle: 'global.menu.sitemap'
            },
            views: {
                'content@': {
                    templateUrl: 'app/sitemap/budget.html',
                    controller: 'SitemapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sitemap');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
